
// import React from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   Container, Row, Col, Card, CardBody,
//   Label, Form, Alert, Input, FormFeedback
// } from 'reactstrap';
// import logoDark from "../../assets/images/logo384.png";
// import logoLight from "../../assets/images/logo384.png";
// import PropTypes from "prop-types";

// // Formik y validaciones
// import * as Yup from "yup";
// import { useFormik } from "formik";

// const Login = () => {
//   document.title = "Login | Lexa - Responsive Bootstrap 5 Admin Dashboard";

//   const [loginError, setLoginError] = React.useState(null);
//   const navigate = useNavigate();

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       email: "",
//       password: "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().email("Email inválido").required("Por favor ingresá tu correo"),
//       password: Yup.string().required("Por favor ingresá tu contraseña"),
//     }),
//     onSubmit: async (values, { setSubmitting }) => {
//       try {
//         const response = await fetch("http://asijeminapis.website:4370/usuarios/login", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             correo: values.email,
//             pass: values.password,
//           }),
//         });

//         const data = await response.json();

//         if (!response.ok) {
//           throw new Error(data.msg || "Error al iniciar sesión");
//         }

//         localStorage.setItem("token", data.token);
//         navigate("/dashboard"); // Redirección correcta

//       } catch (error) {
//         setLoginError(error.message);
//       } finally {
//         setSubmitting(false);
//       }
//     }
//   });

//   return (
//     <React.Fragment>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <CardBody className="pt-0">
//                   <h3 className="text-center mt-5 mb-4">
//                     <Link to="/" className="d-block auth-logo">
//                       <img src={logoDark} alt="" height="110" className="auth-logo-dark" />
//                       <img src={logoLight} alt="" height="110" className="auth-logo-light" />
//                     </Link>
//                   </h3>

//                   <div className="p-3">
//                     <h4 className="text-muted font-size-18 mb-1 text-center">¡Bienvenido de nuevo!</h4>
//                     <p className="text-muted text-center">Iniciá sesión para continuar</p>

//                     <Form
//                       className="form-horizontal mt-4"
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         validation.handleSubmit();
//                         return false;
//                       }}
//                     >
//                       {loginError && <Alert color="danger">{loginError}</Alert>}

//                       <div className="mb-3">
//                         <Label htmlFor="username">Correo</Label>
//                         <Input
//                           name="email"
//                           className="form-control"
//                           placeholder="Ingrese su correo"
//                           type="email"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.email}
//                           invalid={validation.touched.email && !!validation.errors.email}
//                         />
//                         {validation.touched.email && validation.errors.email && (
//                           <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
//                         )}
//                       </div>

//                       <div className="mb-3">
//                         <Label htmlFor="userpassword">Contraseña </Label>
//                         <Input
//                           name="password"
//                           value={validation.values.password}
//                           type="password"
//                           placeholder="Ingrese su contraseña"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           invalid={validation.touched.password && !!validation.errors.password}
//                         />
//                         {validation.touched.password && validation.errors.password && (
//                           <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
//                         )}
//                       </div>

//                       <Row className="mb-3 mt-4">
//                         <div className="col-6">
//                           <div className="form-check">
//                             <input type="checkbox" className="form-check-input" id="customControlInline" />
//                             <label className="form-check-label" htmlFor="customControlInline">Recordarme</label>
//                           </div>
//                         </div>
//                         <div className="col-6 text-end">
//                           <button className="btn btn-primary w-md waves-effect waves-light" type="submit">
//                             Iniciar sesión
//                           </button>
//                         </div>
//                       </Row>

//                       <Row className="form-group mb-0">
//                         <div className="col-12 mt-4">
//                           <Link to="/forgot-password" className="text-muted">
//                             <i className="mdi mdi-lock"></i> ¿Olvidaste tu contraseña?
//                           </Link>
//                         </div>
//                       </Row>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>

//               <div className="mt-5 text-center">
                
//                 © {new Date().getFullYear()} Atletico Minero <span className="d-none d-sm-inline-block"> - Hecho con <i className="mdi mdi-heart text-danger"></i> .</span>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// Login.propTypes = {
//   history: PropTypes.object,
// };

// export default Login;




import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Container, Row, Col, Card, CardBody,
  Label, Form, Alert, Input, FormFeedback
} from 'reactstrap';
import logoDark from "../../assets/images/logo384.png";
import logoLight from "../../assets/images/logo384.png";
import PropTypes from "prop-types";

// Formik y validaciones
import * as Yup from "yup";
import { useFormik } from "formik";
import { useAuth } from "../../context/AuthContext"; // 👈 Importamos el contexto


const Login = () => {
  document.title = "Login | Atletico Minero";

  const [loginError, setLoginError] = React.useState(null);
  const navigate = useNavigate();
  const auth = useAuth(); // 👈 Obtenemos login() del contexto

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Email inválido").required("Por favor ingresá tu correo"),
      password: Yup.string().required("Por favor ingresá tu contraseña"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const response = await fetch("https://asijeminapis.website:4370/usuarios/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            correo: values.email,
            pass: values.password,
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || data.msg || "Error al iniciar sesión");
        }
        

        auth.login(data);         // ✅ Guardamos en el AuthContext
        navigate("/dashboard");   // ✅ Redireccionamos

      } catch (error) {
        const errorMsg = error.message || "Error al iniciar sesión";
      
        // Intenta leer el mensaje real del backend si lo hay
        if (error.response && error.response.json) {
          const json = await error.response.json();
          setLoginError(json.error || errorMsg);
        } else {
          setLoginError(errorMsg);
        }
      
      
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="110" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="110" className="auth-logo-light" />
                    </Link>
                  </h3>

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">¡Bienvenido de nuevo!</h4>
                    <p className="text-muted text-center">Iniciá sesión para continuar</p>

                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {loginError && <Alert color="danger">{loginError}</Alert>}

                      <div className="mb-3">
                        <Label htmlFor="username">Correo</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Ingrese su correo"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email}
                          invalid={validation.touched.email && !!validation.errors.email}
                        />
                        {validation.touched.email && validation.errors.email && (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        )}
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="userpassword">Contraseña </Label>
                        <Input
                          name="password"
                          value={validation.values.password}
                          type="password"
                          placeholder="Ingrese su contraseña"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={validation.touched.password && !!validation.errors.password}
                        />
                        {validation.touched.password && validation.errors.password && (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        )}
                      </div>

                      <Row className="mb-3 mt-4">
                        <div className="col-6">
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" id="customControlInline" />
                            <label className="form-check-label" htmlFor="customControlInline">Recordarme</label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit">
                            Iniciar sesión
                          </button>
                        </div>
                      </Row>

                      <Row className="form-group mb-0">
                        <div className="col-12 mt-4">
                          <Link to="/forgot-password" className="text-muted">
                            <i className="mdi mdi-lock"></i> ¿Olvidaste tu contraseña?
                          </Link>
                        </div>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                © {new Date().getFullYear()} Atletico Minero <span className="d-none d-sm-inline-block"> - Hecho con <i className="mdi mdi-heart text-danger"></i> .</span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Login.propTypes = {
  history: PropTypes.object,
};

export default Login;
